var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPseIconDatasetNotext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.875 15.875",
    height: 60,
    width: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.764 2.903c-1.71.015-3.08.675-3.08 1.484 0 .82 1.406 1.485 3.14 1.485 1.735 0 3.14-.665 3.14-1.485 0-.82-1.406-1.484-3.14-1.484h-.06zm-3.08 2.606v4.049c0 .903 1.636 1.485 2.9 1.485V8.427c0-.56.463-1.027 1.025-1.027h2.356V5.51a2.5 2.5 0 0 1-.763.537c-.649.307-1.51.472-2.378.472-.867 0-1.73-.165-2.378-.472a2.5 2.5 0 0 1-.762-.537z",
    fill: "#007dad"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-13.68 14.3a.767.767 0 0 0-.768.769v3.306c0 .426.342.769.768.769h3.342a.767.767 0 0 0 .769-.769V15.07a.767.767 0 0 0-.769-.769Zm0 .729h1.307v.643h-1.346v-.603c0-.036.004-.04.038-.04zm2.035 0h1.306c.034 0 .041.007.041.04v.603h-1.347zm-2.074 1.371h1.346v.644h-1.346zm2.074 0h1.347v.644h-1.347zm-2.074 1.372h1.346v.643h-1.308c-.033 0-.038-.005-.038-.04zm2.074 0h1.347v.602c0 .034-.007.041-.04.041h-1.307z",
    color: "#000",
    fill: "#8ac9e1",
    style: {
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    },
    transform: "translate(21.76 -6.171)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPseIconDatasetNotext);
export default __webpack_public_path__ + "static/media/pse-icon-dataset-notext.e378af94b5c312a69623187ca5b4b5f3.svg";
export { ForwardRef as ReactComponent };